// extracted by css-extract-rspack-plugin
export default {"dialog":"dialog-ZgVzvy","wide":"wide-X3V8Bd","inner":"inner-hFZbX5","header":"header-Qboq6c","title":"title-tIyeNF","body":"body-MinI40","footer":"footer-L9_lPJ"};